export default __webpack_public_path__ + "static/media/img-store-coffee-tabs.9b74df44.png";